import React, { useState } from 'react';
import { Button } from "../ui/button";
import { AlertTriangle, Loader2 } from "lucide-react";
import { maintenanceService } from '../../services/maintenance/planMaestroService';
import toast from 'react-hot-toast';

interface DeletePlanModalProps {
    open: boolean;
    onClose: () => void;
    onSuccess: () => void;
    planId: number;
    planNombre: string;
}

export const DeletePlanModal: React.FC<DeletePlanModalProps> = ({
    open,
    onClose,
    onSuccess,
    planId,
    planNombre
}) => {
    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        setLoading(true);
        try {
            await maintenanceService.deletePlanMaestro(planId);
            toast.success('Plan eliminado correctamente');
            onSuccess();
            onClose();
        } catch (error: any) {
            console.error('Error deleting plan:', error);
            const msg = error.response?.data?.message || 'Error al eliminar el plan';
            toast.error(msg);
        } finally {
            setLoading(false);
        }
    };

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 animate-in fade-in duration-200">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md overflow-hidden border border-slate-200 animate-in zoom-in-95 duration-200">

                {/* Header with Icon */}
                <div className="p-6 pb-0 flex flex-col items-center text-center">
                    <div className="h-12 w-12 rounded-full bg-red-100 flex items-center justify-center mb-4">
                        <AlertTriangle className="h-6 w-6 text-red-600" />
                    </div>
                    <h2 className="text-xl font-bold text-slate-800 mb-2">
                        ¿Eliminar Plan de Mantenimiento?
                    </h2>
                    <p className="text-sm text-slate-500 mb-6 px-4">
                        Estás a punto de eliminar el plan <span className="font-bold text-slate-700">"{planNombre}"</span>.
                        Esta acción es irreversible y podría afectar a los vehículos asignados.
                    </p>
                </div>

                {/* Footer Buttons */}
                <div className="p-6 pt-0 flex gap-3 justify-center">
                    <Button
                        variant="outline"
                        onClick={onClose}
                        disabled={loading}
                        className="w-full"
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="destructive"
                        onClick={handleDelete}
                        disabled={loading}
                        className="w-full bg-red-600 hover:bg-red-700"
                    >
                        {loading ? (
                            <>
                                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                Eliminando...
                            </>
                        ) : (
                            "Eliminar Plan"
                        )}
                    </Button>
                </div>
            </div>
        </div>
    );
};
